module.exports = __webpack_public_path__ + "f1c9cb77.png";


//////////////////
// WEBPACK FOOTER
// ./public/icons/001-idea.png
// module id = 1466
// module chunks = 4